import { SupportRequestEnums } from '../enums/enums'
import { formatPrice } from './catalog'

/**
 * Billing UI constants (CAR-3710). The PLAN CATALOG is NOT here any more (2026-10-09): plans,
 * prices, highlights and the feature matrix come from the backend (GET /v1/public/billing/catalog,
 * see data/catalog.js and store/CatalogStore.js), which reads them from the database.
 *
 * Self-serve rules: subscribe / reactivate / convert a trial → Stripe Checkout; upgrade → in-app,
 * immediate and prorated; cancel → the Stripe Customer Portal, any time (month-to-month, no
 * minimum term); downgrade → a support ticket, handled by our team. Contact Us remains for
 * Network (QuickBooks) accounts.
 */

// ── Add-ons (PRD §4). Not sold at MVP; kept only so a subscription's `addons` can be labelled.
// (Not part of the data-driven catalog yet — move them to the database before selling add-ons.)
export const ADD_ONS = [
  { key: 'premium_support', name: 'Premium Support', priceLabel: '+$399 / mo', availability: 'any', note: 'Any tier' },
  { key: 'client_portal', name: 'Client Portal', priceLabel: '$99 / shop / mo', availability: 'ai_complete', note: 'AI Complete only' },
  { key: 'connected_group_bonus', name: 'Connected Group Bonus', priceLabel: 'Included', availability: 'any', note: 'Bundled benefit' }
]

export const ADD_ON_BY_KEY = ADD_ONS.reduce((acc, a) => ({ ...acc, [a.key]: a }), {})

// ── Contact Us target — Network (QuickBooks) accounts and anyone who'd rather talk to us. ──
export const CONTACT_US = { href: '/support', label: 'Contact us' }

// Stripe Customer Portal CTAs.
export const PORTAL = {
  label: 'Update payment method',
  addLabel: 'Add payment method',
  manageLabel: 'Manage billing or cancel'
}

/** Add-ons available for a given tier. */
export const addOnsForTier = (tierKey) => ADD_ONS.filter((a) => a.availability === 'any' || a.availability === tierKey)

// ── Downgrades are handled by our team (2026-10-09): the button opens the support form,
// pre-filled as a Technology → Billing request, so nobody can downgrade in the billing portal.
export const SUPPORT_TICKET_PATH = '/support/create-support-request'

/**
 * Router state for CreateSupportRequestPage: ticket type plus a ready-to-send description.
 * `from` / `to` are catalog plans ({ id, name, priceCents }); a bare id is accepted too.
 */
export const downgradeTicketState = (from, to) => {
  const describe = (tier) => {
    if (!tier) return 'another plan'
    if (typeof tier === 'string') return tier
    return tier.priceCents != null ? `${tier.name} (${formatPrice(tier.priceCents)} / location / mo)` : tier.name
  }
  return {
    selectedRecord: {},
    supportType: SupportRequestEnums.CAR_ADASPLUS_TECHNOLOGY,
    requestType: 'BILLING',
    isViewTicketRequest: false,
    // Links the ticket to a downgrade request the admin approves on the ticket (backend plan_change_request).
    downgradeToTier: typeof to === 'string' ? to : to?.id,
    problemDescription: `Plan downgrade request: please move this location from ${describe(from)} to ${describe(to)}.`
  }
}
